export default function UserProfile({ user }) {
    if (!user) return <p>Not logged in</p>;

    return (
        <div className="userprofile">
            <div className="user-avatar">
                {user.name.charAt(0).toUpperCase()}
            </div>
            <div className="user-info">
                <span className="user-name">Welcome, {user.name}</span>
                <span className="user-email">{user.email}</span>
            </div>
        </div>

    );
}
